import { render, staticRenderFns } from "./movGastosAddNew.vue?vue&type=template&id=29c16a0b&"
import script from "./movGastosAddNew.vue?vue&type=script&lang=js&"
export * from "./movGastosAddNew.vue?vue&type=script&lang=js&"
import style0 from "./movGastosAddNew.vue?vue&type=style&index=0&id=29c16a0b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports